import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatiqTemplateMdMarkedService } from './datiq-template-md-marked.service';

@Injectable({
    providedIn: 'root',
})
export class DatiqTemplateMdService {
    constructor(
        private _marked: DatiqTemplateMdMarkedService,
        private _sanitize: DomSanitizer
    ) {}

    render(md: string): string {
        return this._sanitize.sanitize(
            SecurityContext.HTML,
            this._marked.render(md)
        );
    }
}
